import { T } from '@transifex/react';
import type { ReactNode } from 'react';
import { useMatch, useSearchParams } from 'react-router';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '~/components/ui/dialog';

type AuthContainerProps = {
  children: ReactNode;
};

export function AuthContainer({ children }: AuthContainerProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const isLogin = searchParams.get('auth') === 'login';
  const isSignup = searchParams.get('auth') === 'signup';
  const isSignupVerifyPage = Boolean(useMatch('/signup/verify'));
  const isLoginVerifyPage = Boolean(useMatch('/login/verify'));
  const isVerifyPage = isSignupVerifyPage || isLoginVerifyPage;

  const handleClose = (open: boolean) => {
    if (!open) {
      setSearchParams(searchParams => {
        searchParams.delete('auth');
        return searchParams;
      });
    }
  };

  const isOpen = searchParams.has('auth') || isVerifyPage;

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="md:max-w-[560px]">
        <DialogHeader>
          <DialogTitle className="text-h1!">
            {isLogin && <T _str="Log In" />}
            {isSignup && <T _str="Start learning with Startable" />}
            {isSignupVerifyPage && <T _str="Verify your account" />}
            {isLoginVerifyPage && <T _str="Verify your identity" />}
          </DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}
